/**
 * 日付操作ユーティリティ
 */
export default {
  /**
   * 現在日時
   */
  nowDatetime () {
    return new Date()
  },
  /**
   * 今日（時間は00:00）
   */
  nowDate () {
    const now = this.nowDatetime()
    const y = now.getFullYear()
    const m = now.getMonth()
    const d = now.getDate()

    return new Date(y, m, d)
  }
}
